import { useMemo } from 'react';
import { useRoutes, useNavigate } from 'react-router-dom';
import routes from './config';

export const AppRoutes = () => useRoutes(routes);

// Acesso programático à navegação (para código fora dos componentes).
declare global {
  interface Window {
    REACT_APP_NAVIGATE?: (to: string) => void;
  }
}

export function navigate(to: string) {
  window.REACT_APP_NAVIGATE?.(to);
}

export function RouterNavigationBridge() {
  const navigateFromRouter = useNavigate();
  useMemo(() => {
    window.REACT_APP_NAVIGATE = (to: string) => navigateFromRouter(to);
  }, [navigateFromRouter]);
  return null;
}